import { IDataTableColumn } from "nsitools-react";
import * as React from "react";
import { useParams } from "react-router";
import { Link } from "react-router-dom";

import { AllJudgesForBreedApi, BreedJudgeGridDto, BreedJudgeSearch } from "../../../../api";
import { ERoutes } from "../../../../ERoutes";
import { EmailButton, SearchTablePage } from "../../../../components";
import { useGlobalData } from "../../../../contexts";
import { useApiService, useTl } from "../../../../hooks";
import { ETLCodes } from "../../../../locales";

export interface IBreedJudgePageProps {}

export const BreedJudgePage: React.FunctionComponent<IBreedJudgePageProps> = (props) => {
  const api = useApiService(AllJudgesForBreedApi);
  const { t } = useTl();
  const { id } = useParams<{ id: string }>();
  const { currentLanguage } = useGlobalData();

  const columns = React.useMemo<IDataTableColumn[]>(
    () => [
      {
        header: () => t(ETLCodes.LastName),
        fieldName: "lastName",
        render: (row: BreedJudgeGridDto) => (
          <Link target="_blank" to={`${ERoutes.people}/${row.personId}/detail/view`}>
            {row.lastName}
          </Link>
        ),
      },
      {
        header: () => t(ETLCodes.FirstName),
        fieldName: "firstname",
      },
      {
        header: () => t(ETLCodes.Language),
        fieldName: "language",
      },
      {
        header: () => t(ETLCodes.Email),
        fieldName: "email",
        render: (value: BreedJudgeGridDto) => <EmailButton email={value.email} />,
      },
      {
        header: () => t(ETLCodes.PhoneNumber),
        fieldName: "phoneNumber",
      },
      {
        header: () => t(ETLCodes.MobilePhoneNumber),
        fieldName: "mobilePhoneNumber",
      },
    ],
    [t]
  );

  // const selectItemFunction = React.useCallback(() => {
  //   history.push(`${ERoutes.color}/0/detail/edit`);
  // }, [history]);
  const search = React.useCallback(
    (sObj) =>
      api.baseSearch(BreedJudgeSearch.fromJS({ ...sObj, languageId: currentLanguage.languageId, breedId: +id })),
    [api, currentLanguage.languageId, id]
  );
  return (
    // <></>
    <SearchTablePage
      columns={columns}
      searchFunction={search}
      exportFunction={(sObj) =>
        api.exportXlsFile(BreedJudgeSearch.fromJS({ ...sObj, languageId: currentLanguage.languageId, breedId: +id }))
      }
      // addFunc={selectItemFunction}
      sortKeys={{ lastName: "ASC" }}
      withCard={false}
      breadCrumbs={[{ text: t(ETLCodes.Judges) }]}
      // rightElement={
      //   <EditButton
      //     onClick={() => history.push(`${ERoutes.breeds}/${id}/clubs/selector`)}
      //     intent={Intent.PRIMARY}
      //     text={t(ETLCodes.Modify)}
      //   />
      // }
    />
  );
};
